import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Copy = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Copy({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M8.5 4.5H17.25C18.4926 4.5 19.5 5.50736 19.5 6.75V15.5C19.5 15.7761 19.7239 16 20 16H20.5C20.7761 16 21 15.7761 21 15.5V6.75C21 4.67893 19.3211 3 17.25 3H8.5C8.22386 3 8 3.22386 8 3.5V4C8 4.27614 8.22386 4.5 8.5 4.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 8C3 6.89543 3.89543 6 5 6H16C17.1046 6 18 6.89543 18 8V19C18 20.1046 17.1046 21 16 21H5C3.89543 21 3 20.1046 3 19V8ZM5 7.5H16C16.2761 7.5 16.5 7.72386 16.5 8V19C16.5 19.2761 16.2761 19.5 16 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V8C4.5 7.72386 4.72386 7.5 5 7.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'copy-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Copy;
